"use client";

import React, { createContext, useContext } from "react";

export interface TicketEditModeContextValue {
  isEditMode: boolean;
  /** Apply updates to pending state only; does not save to server until savePending() is called */
  onUpdate: (updates: Record<string, unknown>) => void;
  /** Persist all pending changes to the server */
  savePending?: () => Promise<void>;
  refetch?: () => Promise<unknown>;
  /** True when there are unsaved changes */
  hasPendingChanges?: boolean;
}

const TicketEditModeContext = createContext<TicketEditModeContextValue | null>(null);

export function TicketEditModeProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: TicketEditModeContextValue;
}) {
  return (
    <TicketEditModeContext.Provider value={value}>
      {children}
    </TicketEditModeContext.Provider>
  );
}

export function useTicketEditMode(): TicketEditModeContextValue | null {
  return useContext(TicketEditModeContext);
}
